<template>
  <div>
    <h4 class="mt-4">Requirement Types</h4>
    <b-row v-if="requirementTypes.length > 0">
      <b-col cols="3">
        <strong>Name</strong>
      </b-col>
      <b-col cols="3">
        <strong>Prefix</strong>
      </b-col>
      <b-col cols="1">
        <strong>Level</strong>
      </b-col>
    </b-row>
    <div v-for="requirementType in requirementTypes">
      <b-row v-if="currentlyEditingARequirementType && requirementTypeIdBeingEdited === requirementType.requirement_type_id" class="mb-1 mt-1">
        <b-col cols="3">
          <b-form-input type="text"
                        id="requirement-type-name"
                        placeholder="Requirement type name"
                        v-model="updateRequirementTypeName">
          </b-form-input>
        </b-col>
        <b-col cols="3">
          <b-form-input type="text"
                        id="requirement-type-prefix"
                        placeholder="Requirement type prefix"
                        v-model="updateRequirementTypePrefix">
          </b-form-input>
        </b-col>
        <b-col cols="1">
          <b-form-input type="number"
                        id="requirement-type-level"
                        placeholder="Requirement type level"
                        v-model="updateRequirementTypeLevel">
          </b-form-input>
        </b-col>
        <b-col cols="3">
          <b-button-group>
            <b-button variant="primary"
                      size="sm"
                      :disabled="!updateRequirementTypeName || !updateRequirementTypePrefix"
                      @click="updateRequirementType(requirementType.requirement_type_id)">Submit</b-button>
            <b-button size="sm" @click="disableUpdateRequirementTypeForm">Cancel</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row v-else class="mb-1 mt-1">
        <b-col cols="3">
          {{requirementType.name}}
        </b-col>
        <b-col cols="3">
          {{requirementType.prefix}}
        </b-col>
        <b-col cols="1">
          {{requirementType.level}}
        </b-col>
        <b-col cols="3">
          <b-button variant="warning"
                    size="sm"
                    @click="enableUpdateRequirementTypeForm(requirementType)"
                    :disabled="currentlyEditingARequirementType || showNewRequirementTypeForm">Edit</b-button>
          <b-button variant="danger"
                    size="sm"
                    @click="deleteRequirementType(requirementType.requirement_type_id)"
                    :disabled="currentlyEditingARequirementType || showNewRequirementTypeForm">Delete</b-button>
        </b-col>
      </b-row>
    </div>
    <b-row class="mt-2 mb-2">
      <b-col cols="3">
        <b-button variant="primary"
                  @click="enableNewRequirementTypeForm"
                  v-if="!showNewRequirementTypeForm"
                  :disabled="currentlyEditingARequirementType">New requirement type</b-button>
      </b-col>
    </b-row>
    <div class="form-group mt-2 mb-2" v-if="showNewRequirementTypeForm">
      <b-row>
        <b-col cols="3">
          <b-form-input type="text"
                        id="requirement-type-name"
                        placeholder="Requirement type name"
                        v-model="newRequirementTypeName">
          </b-form-input>
        </b-col>
        <b-col cols="3">
          <b-form-input type="text"
                        id="requirement-type-prefix"
                        placeholder="Requirement type prefix"
                        v-model="newRequirementTypePrefix">
          </b-form-input>
        </b-col>
        <b-col cols="3">
          <b-button-group>
            <b-button variant="primary"
                      @click="createRequirementType"
                      :disabled="!newRequirementTypeName || !newRequirementTypePrefix">Submit</b-button>
            <b-button @click="disableNewRequirementTypeForm">Cancel</b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  import RequirementTypesView from '@/components/configuration/RequirementTypesView'
  export default {
    components: {RequirementTypesView},
    mixins: [utilsMixin],
    data () {
      return {
        requirementTypes: [],
        newRequirementTypeName: null,
        newRequirementTypePrefix: null,
        newRequirementTypeLoading: false,
        showNewRequirementTypeForm: false,
        currentlyEditingARequirementType: false,
        requirementTypeIdBeingEdited: null,
        updateRequirementTypeName: null,
        updateRequirementTypePrefix: null,
        updateRequirementTypeLevel: null,
        updateRequirementTypeLoading: false,
        deleteRequirementTypeLoading: false
      }
    },
    methods: {
      createRequirementType () {
        this.newRequirementTypeLoading = true
        this.$http.post(
          '/api/requirement/type',
          {
            requirement_type: {
              name: this.newRequirementTypeName,
              prefix: this.newRequirementTypePrefix}
          }
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Requirement type created successfully',
            type: 'success',
            close: 'auto'
          })
          this.newRequirementTypeLoading = false
          this.getRequirementTypes()
          this.disableNewRequirementTypeForm()
        }, error => {
          this.newRequirementTypeLoading = false
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem saving your requirement type: ${errorString}`,
            type: 'error'
          })
        })
      },
      updateRequirementType (requirementTypeId) {
        this.updateRequirementTypeLoading = true
        this.$http.put(
          `/api/requirement/type/${requirementTypeId}`,
          {
            requirement_type: {
              name: this.updateRequirementTypeName,
              prefix: this.updateRequirementTypePrefix,
              level: this.updateRequirementTypeLevel
            }
          }
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Requirement type updated successfully',
            type: 'success',
            close: 'auto'
          })
          this.updateRequirementTypeLoading = false
          this.getRequirementTypes()
          this.disableUpdateRequirementTypeForm()
        }, error => {
          this.updateRequirementTypeLoading = false
          let errorString = this.createErrorStringFromResponse(error.response.data)
          if (error.response.data && error.response.data.requirement_type) {
            errorString = this.createErrorStringFromResponse(error.response.data.requirement_type)
          }
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem saving your requirement type: ${errorString}`,
            type: 'error'
          })
        })
      },
      deleteRequirementType (requirementTypeId) {
        if (!confirm('Are you sure you want to delete this requirement type? This operation is only allowed if there are no active requirements with this type.')) {
          return
        }
        this.deleteRequirementTypeLoading = true
        this.$http.delete(
          `/api/requirement/type/${requirementTypeId}`
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Requirement type deleted successfully',
            type: 'success',
            close: 'auto'
          })
          this.deleteRequirementTypeLoading = false
          this.getRequirementTypes()
        }, error => {
          this.deleteRequirementTypeLoading = false
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem deleting your requirement type: ${errorString}`,
            type: 'error'
          })
        })
      },
      getRequirementTypes () {
        this.$http.get(
          '/api/requirement/type'
        ).then(response => {
          this.requirementTypes = response.data.requirement_types
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem retrieving your requirement types: ${errorString}`,
            type: 'error'
          })
        })
      },
      enableNewRequirementTypeForm () {
        this.showNewRequirementTypeForm = true
      },
      disableNewRequirementTypeForm () {
        this.showNewRequirementTypeForm = false
        this.newRequirementTypeName = null
        this.newRequirementTypePrefix = null
      },
      enableUpdateRequirementTypeForm (requirementType) {
        this.currentlyEditingARequirementType = true
        this.requirementTypeIdBeingEdited = requirementType.requirement_type_id
        this.updateRequirementTypeName = requirementType.name
        this.updateRequirementTypePrefix = requirementType.prefix
        this.updateRequirementTypeLevel = requirementType.level
      },
      disableUpdateRequirementTypeForm () {
        this.currentlyEditingARequirementType = false
        this.requirementTypeIdBeingEdited = null
        this.updateRequirementTypeName = null
        this.updateRequirementTypePrefix = null
        this.updateRequirementTypeLevel = null
      }
    },
    mounted () {
      this.getRequirementTypes()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// RequirementTypesView.vue?39bde772